import React from 'react'
import business from '../images/business.jpg'
import volunteer from '../images/volunteer.png'
import { Link } from 'react-router-dom'

const LandingPage = () => {
    return (
        <div>
            <h1>Sign Up!</h1>
            <div className='signupcards'>
                <Link to='/registerBusiness' style={{ textDecoration: 'none', color: 'black' }}>
                    <div className='signup'>

                        <img alt="Business" src={business}></img>
                        <h3>I'm a business</h3>
                        <p>I want to donate food</p>
                    </div>
                </Link>
                <Link to='/registerVolunteer' style={{ textDecoration: 'none', color: 'black' }}>
                    <div className='signup'>
                        <img alt="Volunteer" src={volunteer}></img>
                        <h3>I'm a volunteer</h3>
                        <p>I want to receive donations</p>
                    </div>
                </Link>
            </div>
            
                <p>Already have an account? Log in:</p>
                <Link to='/loginBusiness' style={{ textDecoration: 'none'}}>
                    <button className='loginbutton'>Business</button>
                </Link>
                <Link to='/loginVolunteer' style={{ textDecoration: 'none'}}>
                    <button className='loginbutton'>Volunteer</button>
                </Link>
        </div>
    )
}

export default LandingPage